import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  expiresIn: 0,
};

const tokenTestSlice = createSlice({
  name: 'tokenTest',
  initialState,
  reducers: {
    setExpiresIn(state, action) {
      state.expiresIn = action.payload;
    },
  },
});

export const { setExpiresIn } = tokenTestSlice.actions;

export const selectTokenTestExpiresIn = (state) => state.tokenTest.expiresIn;

export default tokenTestSlice.reducer;
